export default "__VITE_ASSET__BFxiylMC__"